import { Renderer2 } from '@angular/core';
import hljs, { AutoHighlightResult, HighlightOptions, HighlightResult } from 'highlight.js';

export class HighlightSyntax {
  constructor(private renderer: Renderer2) {
    this.loadStylesheet();
  }

  /**
   * loads the theme to be used (default: vs.min.css)
   * you can find themes here https://highlightjs.org/demo
   * @param theme string
   */
  public loadStylesheet(theme?: string) {
    const linkElement = this.renderer.createElement('link');
    this.renderer.setAttribute(linkElement, 'rel', 'stylesheet');
    this.renderer.setAttribute(
      linkElement,
      'href',
      `https://cdnjs.cloudflare.com/ajax/libs/highlight.js/11.9.0/styles/${theme ?? 'vs.min.css'}`
    );
    this.renderer.appendChild(document.head, linkElement);
  }

  /**
   * highlights the syntaxt of a given string in the format of the given code language
   * requires a "pre>code{{ string }}<code<pre" structure
   * @param codeOrLanguageName
   * @param optionsOrCode
   * @param ignoreIllegals
   * @returns HighlightResult
   */
  public highlight(
    codeOrLanguageName: string,
    optionsOrCode: string | HighlightOptions,
    ignoreIllegals?: boolean
  ): HighlightResult {
    if (typeof optionsOrCode === 'string') {
      return hljs.highlight(codeOrLanguageName, optionsOrCode, ignoreIllegals);
    } else {
      return hljs.highlight(codeOrLanguageName, optionsOrCode as any, ignoreIllegals);
    }
  }

  /**
   * highlights the syntaxt of a given string in the format of the detected code language
   * requires a "pre>code{{ string }}<code<pre" structure
   * @param code
   * @param languageSubset
   * @returns AutoHighlightResult
   */
  public highlightAuto(code: string, languageSubset?: string[]): AutoHighlightResult {
    return hljs.highlightAuto(code, languageSubset);
  }

  /**
   * highlights the syntaxt of every string wrapped in a "pre>code{{ string }}<code<pre" tag in the format of the detected code language
   */
  public highlightAll(): void {
    return hljs.highlightAll();
  }

  /**
   * highlights the syntaxt of a given HTMLElement text content wrapped in a "pre>code{{ string }}<code<pre" tag in the format of the detected code language
   * @param element
   */
  public highlightElement(element: HTMLElement): void {
    return hljs.highlightElement(element);
  }
}
